import { render, staticRenderFns } from "./postMetaBlock.vue?vue&type=template&id=2d4a8c27&scoped=true"
import script from "./postMetaBlock.vue?vue&type=script&lang=js"
export * from "./postMetaBlock.vue?vue&type=script&lang=js"
import style0 from "./postMetaBlock.vue?vue&type=style&index=0&id=2d4a8c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a8c27",
  null
  
)

export default component.exports